import { ready } from 'brei-project-utils';
import './lib/br-toggle.js'
import './lib/br-tabs.js'

// Example of importing a custom module
// import { primaryNav } from './modules/primaryNav';

const main = {

	consent: null,
	
	elem: {
		consent: document.querySelector('.cookie-consent'),
		tab: document.querySelectorAll('.br-tabs'),
		video: document.querySelectorAll('.video')		
	},

	init() {
		this.bindUIActions();
	},

	bindUIActions() {
		if(main.elem.tab.length > 0) {
			main.elem.tab.forEach( function( element ) {
				element.toggle = Object.assign(new BRTabs(element));
				element.querySelectorAll('.btn').forEach( function( button ) {
					button.addEventListener('click', main.clipText);
				});
			});
		}

		if(main.elem.video.length > 0){
			main.elem.video.forEach( function( element ) {
				element.querySelectorAll('.video__button').forEach( function( button ) {
					button.addEventListener('click', main.playVideo);
				});
			});
		}

		main.consent = localStorage.getItem('consentsToCookies');
		if(main.consent === null) {
			main.elem.consent.setAttribute('aria-hidden', 'false');

			main.elem.consent.querySelectorAll('.btn').forEach(function( button) {
				button.addEventListener('click', function(e) {
					// 0. Get the value of the button clicked ("true" or "false")
					const userChoice = e.currentTarget.value;
					const isGranted = (userChoice === 'true');
					
					// 1. Save the choice to localStorage (Original functionality)					
					localStorage.setItem('consentsToCookies', '{"value":' + userChoice + '}');
					
					// 2. Hide the modal (Original functionality)
					main.elem.consent.setAttribute('aria-hidden', 'true');
					main.elem.consent.style.display = 'none';
					
					// 4. PUSH THE CONSENT UPDATE TO THE DATA LAYER
					// This command updates the consent state in Google Consent Mode (v2)
					window.dataLayer = window.dataLayer || [];
					function gtag() { window.dataLayer.push(arguments); }
					gtag('consent', 'update', {
						'ad_storage': isGranted ? 'granted' : 'denied',
						'analytics_storage': isGranted ? 'granted' : 'denied',
						'ad_user_data': isGranted ? 'granted' : 'denied',
						'ad_personalization': isGranted ? 'granted' : 'denied',
						'functionality_storage': 'granted',
						'security_storage': 'granted'
					});
					window.dataLayer.push({ event: 'consent_granted_update' });
				});				
			});
		}		
	},

	clipText(event) {
		navigator.clipboard.writeText(event.currentTarget.parentNode.querySelector('.tab__message').innerText);
	},

	playVideo(event) {
		let component = event.currentTarget.parentNode;
		component.querySelector('.video__button').remove();
		component.querySelector('.video__poster').remove();
		component.querySelector('.video__video').setAttribute('tabIndex', 0);
		component.querySelector('.video__video').focus();
		component.querySelector('.video__video').play();
	}

};

ready(function () {
	main.init();
});


